import Cookies from 'js-cookie';

import { getCookieDomain } from '../utils';
import { checkStoreId } from './store';

const SET = 'formlabs/i18n/SET';

const initialState = {
  language: null,
  region: null,
  currency: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

const updateLocaleCookie = (language, region, currency) => {
  Cookies.set(
    'locale',
    { region, language, currency },
    { domain: getCookieDomain() }
  );
};

export const setLanguage = language => {
  return {
    type: SET,
    payload: {
      language
    }
  };
};

export const setRegion = region => {
  return {
    type: SET,
    payload: {
      region
    }
  };
};

export const setLocale = (language, region, currency) => {
  return {
    type: SET,
    payload: {
      language,
      region,
      currency
    }
  };
};

export const updateLocale = (language, region, currency) => {
  updateLocaleCookie(language, region, currency);
  return setLocale(language, region, currency);
};

export const checkLocale = (language, region, currency) => {
  const cookieValues = Cookies.getJSON('locale') || {};

  return async (dispatch, getState) => {
    if (
      !cookieValues.language ||
      !cookieValues.region ||
      !cookieValues.currency
    ) {
      await dispatch(
        updateLocale(
          cookieValues.language || language,
          cookieValues.region || region,
          cookieValues.currency || currency
        )
      );
    } else {
      await dispatch(
        setLocale(
          cookieValues.language,
          cookieValues.region,
          cookieValues.currency
        )
      );
    }

    return await dispatch(checkStoreId(language, region));
  };
};
